function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 51.895l26.526-12.2-26.526-1.1-26.526 1.1z",
  fill: "#fcbf91"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.965 17.207v18.72h31.903V6.616L35.6 3.96z",
  fill: "#9d5125"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6 67.96l26.526-18.818-26.6-3.887-26.56 3.887z",
  fill: "#fcbf91"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fill: "#9d5125"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.6 17.24v18.688h14.024v-19.95L45.5 14.324z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.5 23.36v12.567h10.85V22.972l-3.1-.907z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.24 21.03v14.9h8.777l.097-14.964-2.656-1.07z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M40.868 35.928V6.616L35.6 3.96v31.968zm8.745 0v-19.95L45.5 14.324v21.603zm6.737 0V22.972l-3.1-.907v13.862zm3.1 0V19.895l2.656 1.07V35.93zm2.568 3.757v5.603L35.5 51.895V42.34zm.097 14.963v-5.506L35.5 58.535v9.425z",
  fill: "#f58532"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.965 54.713v-5.57L35.5 58.47v9.5zm0-9.425v-5.603L35.5 42.34v9.555z",
  fill: "#9d5125"
});

var SvgKinesis = function SvgKinesis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "3.54 3.96 64 64",
    width: 64,
    height: 64,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKinesis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kinesis.c6d279da.svg";
export { ForwardRef as ReactComponent };